const socialMediaData = ['Instagram', 'LinkedIn', 'Twitter', 'Facebook']

export default socialMediaData
